import Slider from 'react-slick';

import { Slide } from './Slide.jsx';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
        background: 'linear-gradient(270deg, #2D0DAE 0%, #8453D5 100%)',
        opacity: 0.8,
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(270deg, #2D0DAE 0%, #8453D5 100%)',
        opacity: 0.8,
        width: '38px',
        height: '38px',
        borderRadius: '50%',
      }}
      onClick={onClick}
    />
  );
}

export const GoodsSlider = ({ goodsList }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <div className="max-w-108 m-auto px-1 md:px-14 xl:px-20 2xl:px-24 huge:px-36">
      <button onClick={() => this.slider.slickPrev()}></button>
      <Slider {...settings}>
        {goodsList.map((good) => (
          <Slide key={good.id} data={good} />
        ))}
      </Slider>
      <button onClick={() => this.slider.slickPrev()}></button>
    </div>
  );
};
